import * as moment from 'moment';
import { FormEditor } from './../../models/editors/form-editor.base.model';

export class TimePicker extends FormEditor<string> {
    controlType = 'timepicker';

    constructor(options: {} = {}) {
        super(options);
    }
}
